/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://hk.news.yahoo.com/%E6%9C%AC%E5%9C%B0-%E5%A4%A7%E9%87%8F%E6%B8%A3%E6%89%93%E5%AE%A2%E6%88%B6%E4%BF%A1%E7%94%A8%E5%8D%A1%E8%A2%AB%E7%9B%9C%E7%94%A8-%E9%87%91%E7%AE%A1%E5%B1%80-%E8%A6%81%E6%B1%82%E9%8A%80%E8%A1%8C%E6%8E%A1%E5%8F%96%E6%9C%89%E6%95%88%E6%8E%AA%E6%96%BD%E4%BF%9D%E9%9A%9C%E5%AE%A2%E6%88%B6%E5%88%A9%E7%9B%8A-143521259.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAADehC7v5I69Zp7HGhzCyyYdVE7sIIobLAfmpkC3USUR_n4_xhdlx53RnvNRXw-wEyrlCD5QaMJN33JgiWBEyC4WHKbZgOs4qZGOCG3WJttYu74XX6-i9a3BeJhQmRITU7duPiq_K6XOhP-I5q_twJZ8ksq88XHykPon-8GIkChO7'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/418286/%E5%A4%A7%E6%96%B0%E9%8A%80%E8%A1%8C%E7%A8%B1%E6%95%B8%E5%8D%83%E5%AE%A2%E6%88%B6%E6%8E%A5%E7%8D%B2%E5%8F%AF%E7%96%91%E4%BA%A4%E6%98%93%E9%80%9A%E7%9F%A5-%E4%B8%8D%E6%B6%89%E9%87%91%E9%8C%A2%E6%90%8D%E5%A4%B1%E5%8F%8A%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/845362/%E5%B9%B3%E5%AE%89%E5%A3%B9%E8%B3%AC%E9%80%9A%E9%8A%80%E8%A1%8C%E7%99%BC%E7%8F%BE%E5%A4%96%E5%88%A4%E5%AF%A9%E8%A8%88%E9%A1%A7%E5%95%8F-%E6%B6%89%E5%AB%8C%E6%9C%AA%E7%B6%93%E6%8E%88%E6%AC%8A%E7%8D%B2%E5%8F%96%E5%AE%A2%E6%88%B6%E8%B3%87%E6%96%99'
          );
        }}
        className="source3"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://hk.news.yahoo.com/%E6%9C%AC%E5%9C%B0-%E5%A4%A7%E9%87%8F%E6%B8%A3%E6%89%93%E5%AE%A2%E6%88%B6%E4%BF%A1%E7%94%A8%E5%8D%A1%E8%A2%AB%E7%9B%9C%E7%94%A8-%E9%87%91%E7%AE%A1%E5%B1%80-%E8%A6%81%E6%B1%82%E9%8A%80%E8%A1%8C%E6%8E%A1%E5%8F%96%E6%9C%89%E6%95%88%E6%8E%AA%E6%96%BD%E4%BF%9D%E9%9A%9C%E5%AE%A2%E6%88%B6%E5%88%A9%E7%9B%8A-143521259.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAADehC7v5I69Zp7HGhzCyyYdVE7sIIobLAfmpkC3USUR_n4_xhdlx53RnvNRXw-wEyrlCD5QaMJN33JgiWBEyC4WHKbZgOs4qZGOCG3WJttYu74XX6-i9a3BeJhQmRITU7duPiq_K6XOhP-I5q_twJZ8ksq88XHykPon-8GIkChO7'
          );
        }}
        className="source1"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/418286/%E5%A4%A7%E6%96%B0%E9%8A%80%E8%A1%8C%E7%A8%B1%E6%95%B8%E5%8D%83%E5%AE%A2%E6%88%B6%E6%8E%A5%E7%8D%B2%E5%8F%AF%E7%96%91%E4%BA%A4%E6%98%93%E9%80%9A%E7%9F%A5-%E4%B8%8D%E6%B6%89%E9%87%91%E9%8C%A2%E6%90%8D%E5%A4%B1%E5%8F%8A%E8%B3%87%E6%96%99%E5%A4%96%E6%B4%A9'
          );
        }}
        className="source2"
      />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E8%B2%A1%E7%B6%93%E5%BF%AB%E8%A8%8A/845362/%E5%B9%B3%E5%AE%89%E5%A3%B9%E8%B3%AC%E9%80%9A%E9%8A%80%E8%A1%8C%E7%99%BC%E7%8F%BE%E5%A4%96%E5%88%A4%E5%AF%A9%E8%A8%88%E9%A1%A7%E5%95%8F-%E6%B6%89%E5%AB%8C%E6%9C%AA%E7%B6%93%E6%8E%88%E6%AC%8A%E7%8D%B2%E5%8F%96%E5%AE%A2%E6%88%B6%E8%B3%87%E6%96%99'
          );
        }}
        className="source3"
      />
    </div>
  </>
);

export default Components004;
